import React from 'react';
import PropTypes from 'prop-types';
import Vacancy from './Vacancy';

const Department = ({ department, vacancies }) => (
    <div className="vacancy">
        <h3 className="vacancy-title">{department}</h3>
        <hr />
        {vacancies.length && vacancies.map((vacancy) => (
            <Vacancy
                key={vacancy?.id}
                vacancy={vacancy}
            />
        ))}
    </div>
);

Department.propTypes = {
    department: PropTypes.string.isRequired,
    vacancies: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Department;
